/** The `procedure_type` enum, with the labels the admins read in the procedure forms. */
export const PROCEDURE_TYPE_OPTIONS = [
  { value: "PROCEDURE_CLASSIQUE", label: "Procédure classique" },
  { value: "ESCP", label: "Règlement européen des petits litiges" },
] as const;

export type ProcedureType = (typeof PROCEDURE_TYPE_OPTIONS)[number]["value"];

export function getProcedureTypeLabel(type: ProcedureType): string {
  return PROCEDURE_TYPE_OPTIONS.find((option) => option.value === type)?.label ?? type;
}
